import BlocklistDetailsPage from 'components/pages/admin/blocklists/blocklist-details-page'
export default BlocklistDetailsPage
